import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { API_BASE } from './apiConfig'; // ✅ Օգտագործում ենք քո հիմնական API հասցեն

const firebaseConfig = {
  apiKey: "AIzaSyDKfVg7yCHhK9EWpzY-aFgny7YrMBYa7nU",
  authDomain: "mydeliveryapp-aacdf.firebaseapp.com",
  projectId: "mydeliveryapp-aacdf",
  storageBucket: "mydeliveryapp-aacdf.firebasestorage.app",
  messagingSenderId: "28811768754",
  appId: "1:28811768754:web:193a3e180730e0b8576aab",
  measurementId: "G-P549M7Q1RR"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestForToken = async (userId) => {
  if (!userId) return;
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, { 
        vapidKey: "BKkPc9YnjlBOPcIqZuvNTOIgHQtE14Wk1-taouprX1OHmDdX5BiT1H9Ak7ir6VVc-E5pfpRZmhOVjpxom931Uts" 
      });

      if (token) {
        // ✅ Փոխարինեցինք localhost-ը API_BASE-ով
        const response = await fetch(`${API_BASE}/api/auth/update-fcm-token`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
           
          },
          body: JSON.stringify({ userId, fcm_token: token })
        });

        const data = await response.json();
        if (data.success) {
          console.log("🚀 FCM Token synchronized");
        }
      }
    }
  } catch (error) {
    console.error("🔥 Firebase Notification Error:", error);
  }
};